import React from 'react';
export const PRIVACY_CONTENT = <>
    <p data-id="element-677">
      <strong data-id="element-678">1. Recopilación de Información</strong>
      <br data-id="element-679" />
      Recopilamos información cuando te registras en nuestro sitio, realizas una
      compra, o participas en el sitio. La información recopilada incluye tu
      nombre, dirección de correo electrónico y detalles de pago.
    </p>

    <p data-id="element-680">
      <strong data-id="element-681">2. Uso de la Información</strong>
      <br data-id="element-682" />
      Cualquier información que recopilemos de ti puede ser utilizada para:
      personalizar tu experiencia, mejorar nuestro sitio web, procesar
      transacciones y enviar correos electrónicos periódicos.
    </p>

    <p data-id="element-683">
      <strong data-id="element-684">3. Privacidad del Comercio Electrónico</strong>
      <br data-id="element-685" />
      Somos los únicos propietarios de la información recopilada en este sitio.
      Tu información personal no será vendida, intercambiada, transferida o dada
      a ninguna otra empresa por ningún motivo, sin tu consentimiento, excepto
      para el propósito expreso de entregar el producto adquirido.
    </p>

    <p data-id="element-686">
      <strong data-id="element-687">4. Píxel de Meta y Seguimiento</strong>
      <br data-id="element-688" />
      Utilizamos el Píxel de Meta (Facebook) y otras tecnologías de seguimiento
      para comprender cómo interactúas con nuestro sitio web y para optimizar
      nuestras campañas publicitarias. Esto nos permite mostrarte anuncios
      relevantes basados en tus intereses.
    </p>

    <p data-id="element-689">
      <strong data-id="element-690">5. Consentimiento</strong>
      <br data-id="element-691" />
      Al utilizar nuestro sitio, aceptas nuestra política de privacidad.
    </p>
  </>;
export const TERMS_CONTENT = <>
    <p data-id="element-692">
      <strong data-id="element-693">1. Aceptación de los Términos</strong>
      <br data-id="element-694" />
      Al acceder y utilizar este sitio web y adquirir "El Código 888", aceptas
      estar sujeto a estos Términos de Servicio y a todas las leyes y
      regulaciones aplicables.
    </p>

    <p data-id="element-695">
      <strong data-id="element-696">2. Naturaleza del Producto</strong>
      <br data-id="element-697" />
      "El Código 888" es un producto digital (audio y manual en PDF). Al
      realizar la compra, recibirás acceso inmediato para descargar o visualizar
      el contenido. No se enviará ningún producto físico.
    </p>

    <p data-id="element-698">
      <strong data-id="element-699">3. Política de Reembolsos</strong>
      <br data-id="element-700" />
      Debido a la naturaleza digital e inmediatamente accesible de este
      producto, todas las ventas son finales. No ofrecemos reembolsos una vez
      que el producto ha sido entregado digitalmente, a menos que la ley local
      exija lo contrario.
    </p>

    <p data-id="element-701">
      <strong data-id="element-702">4. Propiedad Intelectual</strong>
      <br data-id="element-703" />
      Todo el contenido incluido en este producto (textos, audios, gráficos,
      logotipos) es propiedad exclusiva de El Código 888. Queda estrictamente
      prohibida su reproducción, distribución o reventa sin autorización expresa
      por escrito.
    </p>

    <p data-id="element-704">
      <strong data-id="element-705">5. Exención de Responsabilidad</strong>
      <br data-id="element-706" />
      La información y los audios proporcionados tienen fines puramente
      educativos y de entretenimiento. No garantizamos resultados financieros
      específicos. Los testimonios mostrados son experiencias individuales y no
      constituyen una garantía de resultados similares. No somos asesores
      financieros ni médicos.
    </p>
  </>;